import React, { useEffect} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';

export const BigcommerceLoad = ()=> {
    console.log("load------");
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    
    let signedPayload = searchParams.get('signed_payload');
    let source:any = searchParams.get('source');

    useEffect(()=> {
        
        
        if(signedPayload) { 
            sessionStorage.setItem(LocalStorage.BIGCOMMERCE_CRED, signedPayload);
            sessionStorage.setItem(LocalStorage.BIGCOMMERCE_SOURCE,source);

            console.log('navigate to big commerce-');
            navigate('/bigcommerceconnection');
            

        }

    },[]);

    return(
        <>
        Loading...
        </>
    )
}

